module.exports = __webpack_public_path__ + "static/media/012-malta.dc10425d.svg";